module.exports = __webpack_public_path__ + "static/df02a696a9fe63d8553f2dfc6ffd8fd8.png";